export default __webpack_public_path__ + "static/media/house.899d07ad.svg";